import React, { Component } from "react";
import { connect } from "react-redux";
import { If } from "react-extras";
import FormElement from "../forms/form_element";
import { distribute, putDistributions } from "../../action_managers/distributions";
import { distributionKeyNames } from "../../constants/distribution";
import get from "lodash/get";
import ExternalLink from "./external_link";
import { showSuccess } from "../../actions/app";

class SpotifyDistribution extends Component {
  state = {
    showError: false,
    distributionUrl: "",
    showURL: false,
    showSwitchInstruction: false,
  };

  componentDidMount() {
    const url = this.getURL();
    if (url) {
      this.setState({
        distributionUrl: url,
        showURL: true,
      });
    }
  }

  getShowUUID = () => this.props.showUUID;

  getURL = () => {
    return get(this.props.distributions, [this.getShowUUID(), distributionKeyNames.spotify]);
  };

  distribute = e => {
    e.stopPropagation();
    e.preventDefault();
    this.props.distribute(this.getShowUUID(), [distributionKeyNames.spotify]).then(resp => {
      if (resp.status === 200) {
        if (get(resp, "json.spotify.errCode") === 409) {
          this.setState({ showError: true });
          return;
        }
        this.props.showSuccess(
          "Successfully distributed to Spotify. It may take up to 24 hours for your show to appear."
        );
      }
    });
  };
  submitSpotifyLink = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.putDistributions(this.getShowUUID(), {
      [distributionKeyNames.spotify]: this.state.distributionUrl,
    });
  };
  render() {
    const showURL = this.getURL();
    return (
      <div>
        <If condition={this.state.showError}>
          <div className={"spotify-distribution-error"}>
            Looks like your podcast has already been registered. Click{" "}
            <ExternalLink href="https://support.redcircle.com/en/articles/3222319-updating-spotify-when-switching-to-redcircle">
              here
            </ExternalLink>{" "}
            for help.
          </div>
        </If>
        <If condition={!this.state.showURL}>
          <>
            <button className="btn btn-primary margin-right--large" onClick={this.distribute}>
              Distribute To Spotify
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => this.setState({ showURL: true, showSwitchInstruction: true })}>
              I'm Already On Spotify
            </button>
          </>
        </If>
        <If condition={this.state.showURL}>
          <div className={"distribution-form-row__input-container"}>
            <If condition={this.state.showSwitchInstruction}>
              <div className={"spotify-distribution-error"}>
                If you're switching your podcast to RedCircle, but are already distributed to
                Spotify, enter the URL below, and click{" "}
                <ExternalLink href="https://support.redcircle.com/en/articles/3222319-updating-spotify-when-switching-to-redcircle">
                  here
                </ExternalLink>{" "}
                for help.
              </div>
            </If>
            <FormElement
              validationErrors={this.props.validationErrors}
              input={{ name: "links.spotify" }}
              type="text"
              disabled={!!showURL}
              placeholder={"https://open.spotify.com/show/uuid"}
              value={this.state.distributionUrl}
              onChange={e => this.setState({ distributionUrl: e.target.value })}
            />
            <If condition={!showURL}>
              <button className="btn-primary btn" onClick={this.submitSpotifyLink}>
                Submit
              </button>
            </If>
          </div>
        </If>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    distributions: state.distributions.distributions,
    validationErrors: state.distributions.validationErrors,
  };
}

export default connect(mapStateToProps, {
  showSuccess,
  distribute,
  putDistributions,
})(SpotifyDistribution);
